/** @jsxImportSource @emotion/react */

const styles = {
  bar: {
    display: 'flex',
    alignItems: 'center',
    height: '100px',
    padding: '0 9.4%',
    backgroundColor: '#ffffff',
  },
  logo: {
    height: '28.42px',
  },
  link: {
    height: '28.42px',
  },
}

export default function Topbar() {
  return (
    <div css={styles.bar}>
      <a href={'https://www.wienerberger.de'} target={'_blank'} rel={'noreferrer'} css={styles.link}>
        <img
          css={styles.logo}
          src={'/assets/wienerberger_logo_horizontal.svg'}
          alt={'wienerberger Logo'}
        />
      </a>
    </div>
  )
}
